// extracted by mini-css-extract-plugin
module.exports = {"findPeopleImage":"FindPeople_findPeopleImage__aToFE","closeDiv":"FindPeople_closeDiv__j_t4h"};